/**
 * Created by sisy on 2017/8/23.
 */

export default {
  GET_FAST_MENU: '获取快捷菜单',
  CHANGE_MENU_SIZE: '改变快捷菜单大小',
  CHANGE_HOVER_MENU: '改变鼠标放着的菜单',
  HIDE_MENU: '隐藏菜单',
  SET_MENU_HEIGHT: '设置菜单高度',
  BIG_MENU: '扩展菜单',
  SET_HOME_SCROLLTOP: '设置首页滚动条高度',
  OVER_FASTMENUS_LENGTH: '超过快捷菜单长度',
  SET_ACTIVE_FAST_MENU: '设置活跃的快捷菜单',
  LOADING_START: '全局 loading 开始',
  LOADING_END: '全局 loading 结束',
  SET_SYSTEM_INFO: '设置系统信息',
}
